import { useEffect, useRef, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useWregFlow } from '@/components/webreg/useWregFlow';
import { WREG_VIEW } from '@/components/webreg/wregViews';
import { wregDocTitle, wregTitleKey } from '@/components/webreg/wregTitles';
import { wregStepNumber, type WregStep } from '@/components/webreg/wregSteps';

type Props = {
  step: WregStep;
  children: ReactNode;
};

const WregRoute = ({ step, children }: Props) => {
  const { ready, allowed } = useWregFlow(step);
  const { trackView } = useAnalytics();
  const { t } = useTranslation();
  const seenRef = useRef<WregStep | null>(null);

  useEffect(() => {
    if (!ready || !allowed || seenRef.current === step) return;
    seenRef.current = step;
    trackView({ event: WREG_VIEW[step], properties: { step_number: wregStepNumber(step) } });
  }, [allowed, ready, step, trackView]);

  useEffect(() => {
    if (!ready || !allowed) return;
    document.title = wregDocTitle(t(wregTitleKey(step)));
  }, [allowed, ready, step, t]);

  if (!ready || !allowed) return null;
  return <>{children}</>;
};

export { WregRoute };
